import UserService from './../../service/UserService'
const items = [
   {
      icon: 'home',
      text: 'Início',
      to: '/',
   },
   {
      icon: 'folder_special',
      text: 'Contratos e Licitação',
      children: [],
   },
   {
      icon: 'folder_shared',
      text: 'Operacional',
      children: [],
   },
   {
      icon: 'shopping_cart',
      text: 'Almoxarifado',
      children: [],
   },
   {
      icon: 'ballot',
      text: 'Cadastros Gerais',
      children: [],
   },
]
const childrens = [
   {
      code: 1,
      icon: 'list',
      text: 'Orçamento',
      to: '/budget',
      access: 'budget',
   },
   {
      code: 1,
      icon: 'description',
      text: 'Contrato',
      to: '/contract',
      access: 'contract',
   },

   {
      code: 2,
      icon: 'list_alt',
      text: 'Requisições',
      to: '/requests',
      access: 'requests',
   },
   {
      code: 2,
      icon: 'description',
      text: 'Contratos Inicial',
      to: '/initialapproval',
      access: 'initialapproval',
   },

   {
      code: 3,
      icon: 'assignment',
      text: 'Estoque',
      to: '/stock',
      access: 'stock',
   },

   {
      code: 4,
      icon: 'person',
      text: 'Cliente',
      to: '/client',
      access: 'client',
   },
   {
      code: 4, 
      icon: 'face',
      text: 'Usuário',
      to: '/user',
      access: 'user' 
    },
   {
      code: 4,
      icon: 'business',
      text: 'Empresa',
      to: '/company',
      access: 'company',
   },
   {
      code: 4,
      icon: 'location_city',
      text: 'Cidade',
      to: '/city',
      access: 'city',
   },
   {
      code: 4,
      icon: 'build',
      text: 'Serviço',
      to: '/office',
      access: 'office',
   },
   {
      code: 4,
      icon: 'gavel',
      text: 'Convenção Coletiva',
      to: '/convention',
      access: 'convention',
   },
   {
      code: 4,
      icon: 'all_inbox',
      text: 'Categoria de Produto',
      to: '/category',
      access: 'category',
   },
   {
      code: 4,
      icon: 'move_to_inbox',
      text: 'Produto',
      to: '/product',
      access: 'product',
   },
]


class DrawerItems {
   static getItems(company) {
      items[1].children = [];
      items[2].children = [];
      items[3].children = [];
      items[4].children = [];
      let userAccess = UserService.getOneComapanyOfUser(company)
      for (let index = 0; index < userAccess.length; index++) {
        const element = userAccess[index].entity;
        for (let i = 0; i < childrens.length; i++) {
          if (element == childrens[i].access) {
            items[childrens[i].code].children.push(childrens[i]);
          } 
        } 
      }
      return items
   }
  
}
export default DrawerItems



// WEBPACK FOOTER //
// ./src/data/DrawerItems/Items.js